import { action, observable, runInAction } from 'mobx';
import { PasswordStore, StringStore } from 'ui/base/input';
import { IAccountsDomain } from 'services/accounts/types';
import { ResultKind } from 'services/base/types';
import { LoginResult, SessionService } from 'services/accounts/session_service';
import { BusyStore } from 'ui/base/button';

export class LoginStore {
  readonly email: StringStore;
  readonly password: PasswordStore;

  @observable.ref
  passwordError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.email = new StringStore('');
    this.password = new PasswordStore('');
    this.passwordError = undefined;
    this.busy = new BusyStore();
  }

  @action.bound
  async handleLogin(domain: IAccountsDomain): Promise<LoginResult> {
    this.passwordError = undefined;
    const result = await SessionService.login(
      domain,
      this.email.value,
      this.password.value,
    );
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.passwordError = result.passwordError;
      }
      return result;
    });
  }
}
